// ============================================================
// SUBURB LANDING PAGES
// 20 Brisbane suburbs targeted for local SEO ("cleaning in [suburb]")
// Each generates a unique landing page at /cleaning/{slug}
// To add/remove a suburb: edit this list and rebuild — sitemap auto-updates.
// ============================================================

export const suburbRegions = [
  {
    region: "West / Inner West",
    intro:
      "Beautiful, leafy suburbs known for prestige homes and family living — areas where presentation matters.",
    suburbs: [
      {
        slug: "pullenvale",
        name: "Pullenvale",
        blurb:
          "Large luxury homes, acreage, and presentation-focused households. Ideal for recurring premium cleans.",
      },
      {
        slug: "fig-tree-pocket",
        name: "Fig Tree Pocket",
        blurb:
          "One of Brisbane’s most prestigious pockets — large homes and busy professional families.",
      },
      {
        slug: "brookfield",
        name: "Brookfield",
        blurb:
          "Acreage lifestyle and affluent families who value a beautifully presented home.",
      },
      {
        slug: "indooroopilly",
        name: "Indooroopilly",
        blurb:
          "High-income professionals and established family homes within sought-after school catchments.",
      },
      {
        slug: "chelmer",
        name: "Chelmer",
        blurb:
          "A quiet prestige suburb of beautiful character homes that reward detailed, considered cleaning.",
      },
      {
        slug: "chapel-hill",
        name: "Chapel Hill",
        blurb:
          "Leafy, family-oriented and presentation-conscious — perfect for ongoing maintenance cleans.",
      },
      {
        slug: "kenmore",
        name: "Kenmore",
        blurb:
          "A strong family demographic suited to regular, reliable cleaning schedules.",
      },
      {
        slug: "kenmore-hills",
        name: "Kenmore Hills",
        blurb:
          "An underrated premium pocket of larger homes and discerning homeowners.",
      },
      {
        slug: "karalee",
        name: "Karalee",
        blurb:
          "A peaceful, family-focused riverside community of larger homes and acreage living — naturally suited to ongoing premium cleans.",
      },
      {
        slug: "chuwar",
        name: "Chuwar",
        blurb:
          "A semi-rural riverside pocket adjacent to Karalee — larger homes and acreage that benefit from a meticulous, considered clean.",
      },
      {
        slug: "anstead",
        name: "Anstead",
        blurb:
          "Leafy and family-focused with generous block sizes — ideal for ongoing premium cleaning relationships.",
      },
      {
        slug: "bellbowrie",
        name: "Bellbowrie",
        blurb:
          "A quiet riverside community of larger family homes that reward detailed, presentation-level care.",
      },
      {
        slug: "moggill",
        name: "Moggill",
        blurb:
          "Acreage living and established family homes — a premium pocket on Brisbane’s western corridor.",
      },
      {
        slug: "bardon",
        name: "Bardon",
        blurb:
          "Beautiful character Queenslanders and renovated period homes that thrive with attentive, detailed cleaning.",
      },
      {
        slug: "auchenflower",
        name: "Auchenflower",
        blurb:
          "Inner-west character homes and busy professionals who value reliable, refined service.",
      },
    ],
  },
  {
    region: "Inner East / Riverside",
    intro:
      "Lifestyle-driven, riverside living — homes that pair character with the highest presentation standards.",
    suburbs: [
      {
        slug: "bulimba",
        name: "Bulimba",
        blurb:
          "Lifestyle-driven professionals and premium homes — a community that values quality service.",
      },
      {
        slug: "hawthorne",
        name: "Hawthorne",
        blurb:
          "High-end homes and residents who appreciate refined, presentation-level cleaning.",
      },
      {
        slug: "camp-hill",
        name: "Camp Hill",
        blurb:
          "One of Brisbane’s best suburbs for affluent young families and beautifully kept homes.",
      },
      {
        slug: "coorparoo",
        name: "Coorparoo",
        blurb:
          "Professionals and renovated Queenslanders — convenience-driven households who want it done right.",
      },
      {
        slug: "norman-park",
        name: "Norman Park",
        blurb:
          "Quietly affluent and perfectly suited to ongoing residential cleaning relationships.",
      },
      {
        slug: "carindale",
        name: "Carindale",
        blurb:
          "Established wealth, larger homes, and busy professional families.",
      },
      {
        slug: "east-brisbane",
        name: "East Brisbane",
        blurb:
          "Renovated character homes and lifestyle-focused households moments from the river and the CBD.",
      },
    ],
  },
  {
    region: "Prestige Riverside",
    intro:
      "Brisbane's premier riverside lifestyle suburbs — refined homes, refined expectations.",
    suburbs: [
      {
        slug: "teneriffe",
        name: "Teneriffe",
        blurb:
          "Brisbane's most prestige riverside enclave — converted woolstores, luxury townhouses and apartments that deserve a presentation-led clean.",
      },
      {
        slug: "new-farm",
        name: "New Farm",
        blurb:
          "An iconic riverside suburb of character homes, designer apartments and lifestyle-focused residents who value attention to detail.",
      },
    ],
  },
  {
    region: "Inner North / Character Home Market",
    intro:
      "Brisbane’s heritage heart — older homes that reward the detail and care we bring to every clean.",
    suburbs: [
      {
        slug: "paddington",
        name: "Paddington",
        blurb:
          "Premium character homes and professionals with high presentation standards.",
      },
      {
        slug: "wilston",
        name: "Wilston",
        blurb:
          "A very strong demographic fit for premium, considered cleaning services.",
      },
      {
        slug: "ashgrove",
        name: "Ashgrove",
        blurb:
          "A family-heavy suburb of beautiful older homes that benefit from attentive care.",
      },
      {
        slug: "grange",
        name: "Grange",
        blurb:
          "A quiet premium pocket with strong repeat-client potential.",
      },
      {
        slug: "alderley",
        name: "Alderley",
        blurb:
          "Increasingly affluent and consistently ranked among Brisbane’s most liveable suburbs.",
      },
      {
        slug: "ascot",
        name: "Ascot",
        blurb:
          "A prestige market of affluent homeowners — naturally aligned with premium service.",
      },
      {
        slug: "hamilton",
        name: "Hamilton",
        blurb:
          "Brisbane's blue-ribbon riverside suburb — heritage homes and high-end apartments where presentation is everything.",
      },
      {
        slug: "clayfield",
        name: "Clayfield",
        blurb:
          "Beautifully renovated Queenslanders and established affluent families — an ideal long-term cleaning client base.",
      },
      {
        slug: "hendra",
        name: "Hendra",
        blurb:
          "A quiet, leafy Ascot-adjacent pocket of larger family homes and considered residents.",
      },
      {
        slug: "red-hill",
        name: "Red Hill",
        blurb:
          "Character cottages, sub-tropical Queenslanders and design-led renovations near Paddington — a natural fit for detailed cleaning.",
      },
    ],
  },
];

// Flat list (useful for lookup, sitemap, etc.)
export const allSuburbs = suburbRegions.flatMap((r) =>
  r.suburbs.map((s) => ({ ...s, region: r.region }))
);

export const findSuburb = (slug) =>
  allSuburbs.find((s) => s.slug === slug);
